export default __webpack_public_path__ + "static/media/icon_analytics.d86abe8c.svg";